import * as React from 'react';
import { DraggableCell } from '../../DraggableCell';
export var draggable = function draggable(value, _ref) {
  var rowData = _ref.rowData;
  var id = rowData.id;
  return {
    className: '',
    children: React.createElement(DraggableCell, {
      id: id
    })
  };
};